export default "__VITE_ASSET__RdXaWiJl__"